import React, { useEffect, useState } from "react";
import history from "../history";
import Dropdown from "openstack-uicore-foundation/lib/components/inputs/dropdown";
import { connect } from "react-redux";
import { loadSummits, getSummit } from "../actions/base-actions";
import T from "i18n-react/dist/i18n-react";

// Support inbox and the subject lines the two links pre-fill.
//
// Account deletion gets its own link and its own subject rather than sharing the
// general help line: App Store guideline 5.1.1(v) expects an affordance that
// *initiates* deletion, and a request that arrives indistinguishable from ordinary
// support gets triaged as ordinary support. Deliberately no version or show name in
// the deletion subject — the request is about an account, not a build or an event.
const SUPPORT_EMAIL = "support@fntech.com";
const SUPPORT_SUBJECT = "FNcheckin support";
const DELETION_SUBJECT = "FNcheckin account deletion request";

const SelectSummitPage = ({ 
  accessTokenQS,
  isLoggedUser,
  summit,
  summits,
  loadSummits,
  getSummit
}) => {
    const [includePastSummits, setIncludePastSummits] = useState(false);
    const value = summit ? summit.id : null;

    useEffect(() => {
        if (isLoggedUser || accessTokenQS) {
            loadSummits(includePastSummits);
        }
    }, [isLoggedUser, accessTokenQS, includePastSummits]);

    const onSelectSummit = (ev) => {
        const summitId = ev.target.value;
        const summit = summits.find(s => s.id === summitId);
        getSummit(summit.slug).then(() => {
            history.push(`/check-in/${summit.slug}`);
        });
    };

    const handleCheckboxChange = (ev) => {
        setIncludePastSummits(ev.target.checked);
    };

    const summits_ddl = summits.map(s => ({ label: s.name, value: s.id }));

    return (
      <div className="container summit-select-page">
          <div className="row">
              <div className="col-md-12">
                  <p>{T.translate("general.select_label")}:</p>
                  <Dropdown
                    id="summit"
                    value={value}
                    placeholder={T.translate("general.select_show")}
                    options={summits_ddl}
                    onChange={onSelectSummit}
                  />
              </div>
              <div className="col-md-12 form-check abc-checkbox">
                  <input
                    type="checkbox"
                    id="all_summits"
                    checked={includePastSummits}
                    onChange={handleCheckboxChange}
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="all_summits">
                      {T.translate("general.show_all_summits")}
                  </label>
              </div>
          </div>
          <div className="account-links">
              <p>
                  {T.translate("general.account_help_message", {
                      link: (
                        <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(SUPPORT_SUBJECT)}`}>
                            {SUPPORT_EMAIL}
                        </a>
                      )
                  })}
              </p>
              <p>
                  {T.translate("general.account_delete_message", {
                      link: (
                        <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(DELETION_SUBJECT)}`}>
                            {SUPPORT_EMAIL}
                        </a>
                      )
                  })}
              </p>
              <p>
                  {T.translate("general.account_manage_message", {
                      link: (
                        <a href="https://idp.fnvirtual.app" target="_blank" rel="noopener noreferrer">
                            {T.translate("general.account_manage_link_label")}
                        </a>
                      )
                  })}
              </p>
              <p>
                  {T.translate("general.privacy_rights_message", {
                      link: (
                        <a href="https://www.fntech.com/fntechprivacypolicies/" target="_blank" rel="noopener noreferrer">
                            www.fntech.com/fntechprivacypolicies
                        </a>
                      )
                  })}
              </p>
          </div>
      </div>
    );
};

const mapStateToProps = ({ baseState, loggedUserState }) => ({
    isLoggedUser: loggedUserState.isLoggedUser,
    ...baseState
});

export default connect(mapStateToProps, {
    loadSummits,
    getSummit
})(SelectSummitPage);
